import { useAuth } from '@/context/AuthContext';
import { auth } from '@/lib/firebase';
import { signOut } from 'firebase/auth';

export default function EmployeeDashboard() {
  const { user } = useAuth();

  const handleLogout = () => {
    signOut(auth);
  };

  return (
    <div className="min-h-screen bg-slate-900 text-white font-sans">
      <nav className="bg-slate-800/50 backdrop-blur-md p-4 border-b border-slate-700 flex justify-between items-center">
        <div className="flex items-center gap-2">
          <span className="text-2xl font-bold bg-gradient-to-r from-emerald-400 to-cyan-400 bg-clip-text text-transparent">
            Smart CRM
          </span>
          <span className="bg-cyan-500/10 text-cyan-400 text-xs px-2 py-1 rounded-full font-medium border border-cyan-500/20">
            Empleado
          </span>
        </div>
        <div className="flex items-center gap-4">
          <span className="text-slate-300 text-sm hidden md:block">{user?.email}</span>
          <button
            onClick={handleLogout}
            className="px-4 py-2 bg-slate-700 hover:bg-slate-600 rounded-lg transition-colors text-sm font-medium"
          >
            Cerrar Sesión
          </button>
        </div>
      </nav>
      
      <main className="p-8">
        <header className="mb-8">
          <h2 className="text-3xl font-bold">Panel de Empleado</h2>
          <p className="text-slate-400 mt-1">Gestiona tus tareas y clientes asignados.</p>
        </header>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-slate-800/50 p-6 rounded-xl border border-slate-700 hover:border-cyan-500/50 transition-colors">
            <h3 className="text-sm font-medium mb-2 text-slate-400">Mis Clientes</h3>
            <p className="text-4xl font-bold bg-gradient-to-r from-cyan-400 to-cyan-200 bg-clip-text text-transparent">25</p>
          </div>
          <div className="bg-slate-800/50 p-6 rounded-xl border border-slate-700 hover:border-emerald-500/50 transition-colors">
            <h3 className="text-sm font-medium mb-2 text-slate-400">Tareas Pendientes</h3>
            <p className="text-4xl font-bold bg-gradient-to-r from-emerald-400 to-emerald-200 bg-clip-text text-transparent">5</p>
          </div>
          <div className="bg-slate-800/50 p-6 rounded-xl border border-slate-700 hover:border-purple-500/50 transition-colors">
            <h3 className="text-sm font-medium mb-2 text-slate-400">Mensajes Nuevos</h3>
            <p className="text-4xl font-bold bg-gradient-to-r from-purple-400 to-purple-200 bg-clip-text text-transparent">3</p>
          </div>
        </div>
        
        <div className="mt-8 bg-slate-800/50 p-6 rounded-xl border border-slate-700">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-xl font-semibold text-slate-200">Tareas Pendientes</h3>
            <button className="text-sm text-cyan-400 hover:text-cyan-300 font-medium transition-colors">
              Ver todas
            </button>
          </div>
          
          <div className="space-y-3">
            <div className="p-4 bg-slate-700/30 rounded-lg flex justify-between items-center hover:bg-slate-700/50 transition-colors">
              <div>
                <p className="font-medium text-slate-200">Llamar a Cliente X</p>
                <p className="text-sm text-slate-400">Hoy a las 3:00 PM</p>
              </div>
              <span className="bg-amber-500/10 text-amber-500 text-xs px-2 py-1 rounded-full font-medium border border-amber-500/20">
                Pendiente
              </span>
            </div>
            <div className="p-4 bg-slate-700/30 rounded-lg flex justify-between items-center hover:bg-slate-700/50 transition-colors">
              <div>
                <p className="font-medium text-slate-200">Enviar propuesta a Cliente Y</p>
                <p className="text-sm text-slate-400">Mañana</p>
              </div>
              <span className="bg-amber-500/10 text-amber-500 text-xs px-2 py-1 rounded-full font-medium border border-amber-500/20">
                Pendiente
              </span>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
